import {BreadcrumbProvider} from '@/components/breadcrumb-app/breadcrumb-provider.jsx';
import {useBreadcrumb} from '@/components/breadcrumb-app/use-breadcrumb.js';

export default {
  BreadcrumbProvider,
  useBreadcrumb,
};
